export const DigitalPulpitMark = ({ size = 44 }) => (
  <svg width={size} height={size * 1.15} viewBox="0 0 48 56" fill="none" aria-hidden="true">
    <path d="M8 18 A16 16 0 0 1 40 18" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
    <path d="M3.5 18 A20.5 20.5 0 0 1 44.5 18" stroke="#D4AF37" strokeWidth="1.6" strokeLinecap="round" opacity="0.65" />
    <path d="M12.5 18 A11.5 11.5 0 0 1 35.5 18" stroke="#D4AF37" strokeWidth="1.6" strokeLinecap="round" opacity="0.85" />
    <line x1="24" y1="0.5" x2="24" y2="7" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
    <line x1="20.5" y1="3.5" x2="27.5" y2="3.5" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
    <path d="M19.5 18 L24 8.5 L28.5 18 Z" fill="#D4AF37" />
    <rect x="14" y="18" width="20" height="36" rx="3.5" stroke="#D4AF37" strokeWidth="2" fill="#FFFFFF" />
    <path d="M21.5 31 L28 34.5 L21.5 38 Z" fill="#D4AF37" />
    <line x1="21" y1="50" x2="27" y2="50" stroke="#D4AF37" strokeWidth="1.6" strokeLinecap="round" opacity="0.7" />
  </svg>
);

export default function Logo() {
  return (
    <a href="#top" data-testid="brand-logo" className="flex items-center gap-3 group">
      <DigitalPulpitMark />
      <span className="leading-none">
        <span className="block font-bebas text-lg sm:text-xl tracking-[0.08em] text-white group-hover:text-gold transition-colors">
          MINISTER <span className="text-gold group-hover:text-white transition-colors">OF SOCIAL MEDIA</span>
          <sup className="text-[8px] ml-0.5">TM</sup>
        </span>
        <span className="block text-[8px] sm:text-[9px] tracking-[0.32em] text-white/45 font-faith mt-1.5">
          A KINGDOM REACH MEDIA COMPANY
        </span>
      </span>
    </a>
  );
}
